import { render, staticRenderFns } from "./dcsview.vue?vue&type=template&id=484871bc&"
import script from "./dcsview.vue?vue&type=script&lang=js&"
export * from "./dcsview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports